import "./admin.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import { API_URL } from "../constants";
import UserTable from "./UserTable";
import axios from 'axios';
import AddUserForm from "./AddUserForm";
import EditUserForm from "./EditUserForm";
import ChangePasswordForm from "./ChangePasswordForm";
import EditNameUser from "./EditNameUser";
import ChangeTypeForm from "./ChangeTypeForm";
import MachineAgency from "./MachineAgency";
import MachineType from "./MachineType";
import EmailFrequencySelector from "./EmailFrequencySelector";
import { UserTypes } from "../constants";

export default function Admin(props) {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : props.user;
  const token = user.auth_token;
  const navigate = useNavigate();

  const initialMaintenanceFrequency = localStorage.getItem("maintenanceFrequency") || "daily";
  const [maintenanceFrequency, setMaintenanceFrequency] = useState(initialMaintenanceFrequency);
  const [users, setUsers] = useState([{ _id: "", email: "" }]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [id, setId] = useState();
  const [mail, setMail] = useState();
  const [messagemail, setMessageMail] = useState();
  const [message, setMessage] = useState();
  const [messageSupp, setMessageSupp] = useState();
  const [messageMoteur, setMessageMoteur] = useState();
  const [messageMoteurErreur, setMessageMoteurErreur] = useState();
  const userType = user.type;

  const showMessagePopup = (message) => alert(message);

  const clearMessages = () => {
    setTimeout(() => {
      setMessageMail(null);
      setMessage(null);
      setMessageSupp(null);
      setMessageMoteur(null);
      setMessageMoteurErreur(null);
    }, 5000);
  };

  const handleUserSelection = (userId) => setId(userId);

  useEffect(() => { clearMessages(); }, [messagemail, message, messageSupp, messageMoteur, messageMoteurErreur]);

  useEffect(() => {
    axios.get(`${API_URL}/users`, {
      params: { offset: (page - 1) * limit, limit },
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    })
      .then(response => {
        setUsers(response.data.data);
      })
      .catch(() => {});
  }, [token, page, limit]);

  function rafraichir() {
    axios.get(`${API_URL}/users`, {
      params: { offset: (page - 1) * limit, limit },
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    })
      .then(response => {
        setUsers(response.data.data);
      })
      .catch(error => {
        if (error.response?.status === 401) {
          showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
          localStorage.clear();
          navigate('/login');
        }
      });
  }

  function suppr(id_utilisateur, userData) {
    axios.delete(`${API_URL}/users/${id_utilisateur}`, {
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
      data: userData
    })
      .then(response => {
        setMessageSupp(response.data.message);
        rafraichir();
      })
      .catch(error => {
        if (error.response?.status === 401) {
          showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
          localStorage.clear();
          navigate('/login');
        }
      });
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header user={user} />

      <main className="flex-1 px-4 py-8 max-w-screen-2xl mx-auto w-full">
        {/* Page title */}
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-loginBordure tracking-tight">
            {userType === UserTypes.CHEFAG ? "Ajout Utilisateurs" : "Gestion Utilisateurs"}
          </h1>
          <p className="text-gray-500 text-sm mt-1">Administrez les comptes et paramètres de la plateforme</p>
        </div>

        <div className="flex flex-col xl:flex-row gap-6">

          {/* ── Colonne gauche : tableau ── */}
          <div className="flex-1 min-w-0">
            {messageSupp && (
              <div className="mb-4 flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-xl px-4 py-3 text-sm font-medium">
                <span className="w-2 h-2 rounded-full bg-emerald-500 shrink-0" />
                {messageSupp}
              </div>
            )}

            {userType !== UserTypes.CHEFAG && (
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <UserTable
                  users={users}
                  deleteUser={suppr}
                  setSelectedUserId={handleUserSelection}
                  setSelectedUserEmail={setMail}
                  rafraichir={rafraichir}
                  token={token}
                />

                {/* Pagination bar */}
                <div className="border-t border-gray-100 px-4 py-3 flex flex-wrap items-center gap-3">
                  <span className="text-sm text-gray-500 font-medium">Par page :</span>
                  <div className="flex gap-1">
                    {[5, 10, 20, 50].map(val => (
                      <button
                        key={val}
                        onClick={() => { setLimit(val); setPage(1); }}
                        type="button"
                        className={`px-3 py-1 rounded-lg text-sm font-medium transition-all duration-150
                          ${limit === val
                            ? 'bg-loginBordure text-white shadow-sm'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                          }`}
                      >
                        {val}
                      </button>
                    ))}
                  </div>
                  <input
                    type="number"
                    value={limit}
                    min={1}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      if (val > 0) { setLimit(val); setPage(1); }
                    }}
                    className="w-16 border border-gray-200 rounded-lg px-2 py-1 text-sm text-center focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure"
                  />
                </div>
              </div>
            )}
          </div>

          {/* ── Colonne droite : formulaires ── */}
          <div className="w-full xl:w-96 2xl:w-[28rem] flex flex-col gap-4">

            {/* Ajout utilisateur */}
            <Card>
              <AddUserForm rafraichir={rafraichir} token={token} />
            </Card>

            {/* Agences & types machine */}
            {(userType === UserTypes.SUPER || userType === UserTypes.ADMIN) && (
              <>
                <Card>
                  <MachineAgency token={token} />
                </Card>
                <Card>
                  <MachineType token={token} />
                </Card>
              </>
            )}

            {/* Fréquence email */}
            {[UserTypes.SUPER, UserTypes.ADMIN, UserTypes.CHEFAG, UserTypes.CHEFAT].includes(userType) && (
              <Card>
                <EmailFrequencySelector
                  maintenanceFrequency={maintenanceFrequency}
                  setMaintenanceFrequency={setMaintenanceFrequency}
                />
              </Card>
            )}

            {/* Édition utilisateur sélectionné */}
            {id && userType !== UserTypes.CHEFAG && (
              <Card>
                <div className="mb-4 pb-3 border-b border-gray-100">
                  <p className="text-xs uppercase tracking-widest text-gray-400 font-semibold mb-0.5">Utilisateur sélectionné</p>
                  <p className="text-loginBordure font-semibold text-base truncate">{mail}</p>
                </div>
                <div className="flex flex-col gap-4 divide-y divide-gray-100">
                  <Section title="Identité & téléphone">
                    <EditNameUser id={id} rafraichir={rafraichir} token={token} />
                  </Section>
                  <Section title="Adresse e-mail">
                    <EditUserForm id={id} rafraichir={rafraichir} token={token} />
                  </Section>
                  <Section title="Mot de passe">
                    <ChangePasswordForm id={id} rafraichir={rafraichir} token={token} />
                  </Section>
                  <Section title="Niveau d'accès">
                    <ChangeTypeForm id={id} rafraichir={rafraichir} token={token} />
                  </Section>
                </div>
              </Card>
            )}

          </div>
        </div>
      </main>
    </div>
  );
}

function Card({ children }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5">
      {children}
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="pt-4 first:pt-0">
      <p className="text-xs uppercase tracking-widest text-gray-400 font-semibold mb-3">{title}</p>
      {children}
    </div>
  );
}